export default ".pointer {\n  cursor: pointer;\n}"